require('./bootstrap');

// Import modules...
import { createApp, h } from "vue";
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import store from '@/Store/store';
import global_mixins from '@/mixins/global_mixins';
import VueCookies from 'vue3-cookies';
import mitt from 'mitt';
import vSelect from "vue-select-3/src/index";
import LottieAnimation from "lottie-web-vue";
import mixpanel from 'mixpanel-browser';
import {Inertia} from "@inertiajs/inertia";


mixpanel.init(process.env.MIX_MIXPANEL_TOKEN, {
    ignore_dnt: true,
    debug: true,
});

window.mixpanel = mixpanel;
window.mixpanel_token = process.env.MIX_MIXPANEL_TOKEN;

Inertia.on('navigate', (e) => {
    if( ! /^http:\/\/localhost/.test(window.location.href)  ){
        setTimeout(() => mixpanel.track('VISIT', {title: document.title}), 100);
    }
});

const el = document.getElementById('app');

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
});

const emitter = mitt();
app.config.globalProperties.emitter = emitter;

app
    .mixin({ methods: { route } })
    .mixin(global_mixins)
    .use(InertiaPlugin)
    .use(store)
    .component('v-select', vSelect)
    .use(LottieAnimation)
    .use(VueGoogleMaps, {
        load: {
            // TODO: Move credentials to .env & also setup in CI/CD.
            key: 'AIzaSyCWkqszhLUvBOFDElJIWDPa3klv9YLFtlU',
            libraries: 'places',
        },
    })
    .use(VueCookies, {
        expireTimes: '30d',
        path: '/',
        domain: '',
        secure: true,
    });

app.mount(el);

InertiaProgress.init({ color: '#ee1651' });
